import { IQuiz } from '../IQuiz'

export const srpPatterns5: IQuiz = {
  name: 'srp-patterns-5',
  question: 'В чём потенциальная опасность фасада?',
  variants: [
    {
      text: 'Может превратиться в божественный объект'
    },
    {
      text: 'Скрывает настоящую логику вызова методов, что увеличивает сложность',
      description:
        'Верно лишь отчасти. При адекватном названии методов фасада он снижает сложность и упрощает понимание, так как называет сложные операции более простыми именами'
    },
    {
      text: 'При бесконтрольном использовании увеличивает количество сущностей, что усложняет код'
    }
  ],
  meta: {
    correctAnswers: [0, 2]
  }
}
